<template>
  <div class="cc-steps-bar">
    <template v-for="(label, i) in steps">
      <div :key="'step-' + i" :class="['cc-step', stepStatus(i)]">
        <div class="cc-step-circle">{{ stepStatus(i) === 'done' ? '✓' : i + 1 }}</div>
        <div class="cc-step-lbl">{{ label }}</div>
      </div>
      <div v-if="i < steps.length - 1" :key="'line-' + i" :class="['cc-step-line', { done: i + 1 < currentStep }]" />
    </template>
  </div>
</template>

<script>
export default {
  name: 'CampaignStepsBar',
  props: {
    steps: {
      type: Array,
      default: () => ['Nudge Type', 'Audience', 'Content', 'Send Window', 'Review']
    },
    currentStep: {
      type: Number,
      default: 1
    }
  },
  methods: {
    stepStatus (i) {
      const stepNumber = i + 1
      if (stepNumber < this.currentStep) return 'done'
      if (stepNumber === this.currentStep) return 'active'
      return 'pending'
    }
  }
}
</script>
<style scoped src="./CampaignStepsBar.css"></style>



// WEBPACK FOOTER //
// CampaignStepsBar.vue?5ce69834